import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Box } from '@mui/material';
import EstimateDetails from '../components/estimates/EstimateDetails';
import { EstimateDataProvider } from '../contexts/EstimateDataContext';
import { Estimate } from './EstimatesPage';
import { getEstimate } from '../services/estimateService';

const EstimateDetailPage: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const [estimate, setEstimate] = useState<Estimate | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadEstimate = async () => {
      if (!id) {
        navigate('/app/estimates');
        return;
      }

      try {
        setLoading(true);
        const fullEst = await getEstimate(Number(id));
        const est: Estimate = {
          id: fullEst.id,
          estimateNumber: fullEst.estimate_number,
          name: fullEst.name,
          objectName: fullEst.object_name,
          client: fullEst.client,
          createdAt: fullEst.prepared_at,
          updatedAt: fullEst.updated_at,
          status: fullEst.status === 'finished' ? 'completed' : 'draft',
          kz: +fullEst.markup_kz,
          kp: +fullEst.markup_kp,
          z: +fullEst.markup_z,
          rg: Number(fullEst.rg ?? 0),
          vat: +fullEst.vat,
          positions: fullEst.positions,
          settings: {
            currency: (fullEst as any).currency || 'zł',
            precisionUnitPrice: (fullEst as any).precision_unit_price ?? 2,
            precisionRmsPrice: (fullEst as any).precision_rms_price ?? 3,
            precisionQuantity: (fullEst as any).precision_quantity ?? 3,
            precisionExpenses: (fullEst as any).precision_expenses ?? 4,
            precisionNorm: (fullEst as any).precision_norm ?? 6,
          }
        } as any;
        setEstimate(est);
      } catch (err) {
        console.error('Błąd podczas ładowania kosztorysu:', err);
        navigate('/app/estimates');
      } finally {
        setLoading(false);
      }
    };

    loadEstimate();
  }, [id, navigate]);

  const handleBack = () => {
    navigate('/app/estimates');
  };

  if (loading) {
    return (
      <Box sx={{ p: 3 }}>
        Ładowanie...
      </Box>
    );
  }

  if (!estimate) {
    return null;
  }

  return (
    <Box sx={{ width: '100%' }}>
      <EstimateDataProvider>
        <EstimateDetails 
          estimate={estimate}
          onBack={handleBack}
        />
      </EstimateDataProvider>
    </Box>
  );
};

export default EstimateDetailPage;

